import 'jquery';

(function (document, $) {
  $('body').on('click', 'button[data-loginidentifier]', function () {
    let form = $(this).closest('form');
    form.find(':input').each(function () {
      $(this).prop('required', false);
    });
    form.attr('action', $(this).data('loginidentifier'));
    form.submit();
  });
}(document, jQuery));
